import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadRuntimeConfig } from './runtime/runtimeConfig';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// One bundle serves two kinds of origin (a tenant container, the admin app).
// Learn which one this is before anything renders; a failed fetch means
// today's behaviour (full mode), never a blank page.
loadRuntimeConfig().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
